<template>
	<div style="background-color:#fffcf7;" class="container">
		<headMenu />
		<div class="main_sgn">
            <div style="display: flex; flex-direction: row-reverse; margin: 0;">
                <img 
                width="17.5" 
                :src="require('../../../assets/img/Arrow_Left_black.svg')" 
                @click="()=>{this.$router.go(-1);}"
                class="pointer"
                />
            </div>
            <div class="container">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <router-link to="/getPhone">
                        <img 
                        class="w-100 pointer border-hover"
                        :src="require('../../../assets/img/cad_login.svg')"
                        title="ثبت نام کاربر"
                        alt="ثبت نام کاربر"
                        />
                    </router-link>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <router-link to="/signupTeacher">
                        <img 
                        class="w-100 pointer border-hover"
                        title="ثبت نام اساتید"
                        alt="ثبت نام اساتید"
                        :src="require('../../../assets/img/ost_login.svg')"
                        />
                    </router-link>
                  </div>
                </div>
              </div>
        </div>
		<footerPage /> 
	</div>
</template>

<script>
	import headMenu from  "../../../menu/headMenu.vue";
    import footerPage from  "../../../UI/footer/footer.vue";

	export default {
        name: 'signup_all',
		data(){
			return {

			}
		},
		components: {
			headMenu,
            footerPage,
		},
			props: [],
		mounted(){
			this.$localStorage.remove('user');
		},
		methods:{
			
		}
	}
</script>
<style scoped>
.main_sgn{
    width: 100%;
    max-width: 817px;
    background-color: white;
    padding: 24px;
    border-radius: 20px;
    box-shadow: 0px 4px 4px 0px #00000040;
    margin: auto;
}
.border-hover:hover{
    border: 1px solid #ABABAB !important;
    border-radius: 16px !important;
}
</style>
